import { observable } from 'mobx';

import NetworkStore from './netWork';
import Lend from './lend';
import System from './system';

import Config from '../config';

class RootStore {
  constructor() {
    this.network = new NetworkStore(this);
    this.lend = new Lend(this);
    this.system = new System(this);
  }
}

const store = new RootStore();
export default store;
